import { Button } from '@1trading/react/components/ui/button';
import { GradientIcon } from '@1trading/react/components/ui/gradient-icon';
import { CircleCheck } from 'lucide-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import BaseLayout from '@/layouts/base';

const REDIRECT_DELAY_MS = 5_000;

const PeriodicReviewCompletePage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.location.assign(import.meta.env.VITE_APP_EXCHANGE_URL);
    }, REDIRECT_DELAY_MS);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <BaseLayout className="-md:justify-center space-y-8" size="sm">
      <GradientIcon className="size-32 mx-auto" strokeWidth={1.5}>
        <CircleCheck />
      </GradientIcon>
      <PageHeading centered>
        <PageHeadingTitle>{t('periodicReview.complete.title')}</PageHeadingTitle>
        <PageHeadingDescription>{t('periodicReview.complete.description')}</PageHeadingDescription>
        <PageHeadingDescription>{t('onboardingProgress.complete.redirecting')}</PageHeadingDescription>
      </PageHeading>
      <Button size="lg" variant="primary" asChild>
        <a href={import.meta.env.VITE_APP_EXCHANGE_URL}>{t('buttons.continue')}</a>
      </Button>
    </BaseLayout>
  );
};
PeriodicReviewCompletePage.displayName = 'PeriodicReviewCompletePage';

export default PeriodicReviewCompletePage;
